// RF_bugsnag
import Bugsnag from '../plugins/bugsnag'
import mixpanel from '../plugins/mixPanel'
import {
  getRandomiseFlowDecision,
  setToLocalStorage,
  getFromLocal
} from '../services/UtilService'
import { params } from '../localData/index'
import { UBORoles } from '../consts'

const funcs = {
  isFromLiliApp: () => {
    let origins = ['Lili', 'liliapp']
    let status = false
    origins.map(origin => {
      if (navigator.userAgent.toLowerCase().includes(origin.toLowerCase())) {
        status = true
      }
    })
    return status
  },
  startTrial: function (self) {
    try {
      // FB, Google
      // window.fbq('init', process.env.VUE_APP_FACEBOOK_PIXEL)
      // self.$mam.event('StartTrial') // Ignore start trial event on FB
      // Mix Panel
      mixpanel.track('Start Onboarding', {
        CanSelectPlan: self.$customerDetails.isAccountTypeFlow,
        DefaultPlanSelected: 'Smart',
        FirstCard: self.$customerDetails.isAccountTypeFlow ? 'Smart' : 'N/A',
        isReferral: !!self.$customerDetails.referralCode,
        referralCode: self.$customerDetails.referralCode
          ? self.$customerDetails.referralCode
          : '',
        isFromLiliApp: this.isFromLiliApp(),
        DesignVerion: 'New',
        utmPartner: this.getPartnerUtm(self),
        FlowId: 'Dnb embedded'
      })
      // Google ads
      self.$gtm.trackEvent({
        event: 'start_trial'
      })
    } catch (err) {
      Bugsnag.notify(JSON.stringify('Error on startTrial', err))
    }
  },
  getAbTestFlowId: () => {
    try {
      /** Allow Mobile */
      // if (/Mobi/.test(navigator.userAgent)) {
      //   return 'Control'
      // }

      if ('convert' in window) {
        /** Talk to CPA A/B test IDs */
        const tableTestIds = ['1004120072', '1004120074']
        const experimentsObject = window.convert.currentData.experiments
        for (const key in experimentsObject) {
          let variationId = experimentsObject[key].variation_id
          if (typeof variationId === 'string') {
            variationId = parseInt(variationId)
          }

          if (tableTestIds.includes(JSON.stringify(variationId))) {
            return 'Variation'
          }
        }
        return 'Control'
      } else {
        return 'Control'
      }
    } catch (err) {
      Bugsnag.notify(JSON.stringify('Error on getAbTestFlowId', err))
    }
  },
  getPartnerUtm: function (self) {
    try {
      let adSource = JSON.parse(self.$customerDetails.adSource)
      if (adSource.utm_campaign) {
        return adSource.utm_campaign
      } else {
        return ''
      }
    } catch (e) {
      return ''
    }
  },
  calcValue: function (self) {
    if (
      self.$lastResponse &&
      self.$lastResponse.data &&
      self.$lastResponse.data.value
    ) {
      return self.$lastResponse.data.value
    }
    let valueList = {
      IOS: {
        Accounting: 93,
        Art: 122,
        Beauty: 135,
        'Business Consultant': 122,
        Caregiving: 61,
        'Cleaning/Housekeeping': 103,
        Construction: 134,
        'Cooking/Food': 70,
        Design: 102,
        'Digital Marketing/Social Media': 123,
        'Driving/Delivery': 120,
        Education: 55,
        Entertainment: 122,
        Entrepreneur: 117,
        'Health/Therapy': 105,
        'Human Resources': 87,
        'Insurance/Benefits Agent': 81,
        Legal: 70,
        'Maintenance/Repair': 156,
        Modeling: 108,
        'Photography/Videography': 156,
        'Programming/IT': 139,
        'Real Estate': 104,
        Sales: 97,
        Security: 48,
        'Sports/Fitness': 81,
        'Translation/Writing': 118,
        'Retail / E-Commerce': 172
      },
      ANDROID: {
        'Retail / E-Commerce': 172,
        Accounting: 76,
        Art: 85,
        Beauty: 88,
        'Business Consultant': 102,
        Caregiving: 51,
        'Cleaning/Housekeeping': 65,
        Construction: 70,
        'Cooking/Food': 45,
        Design: 89,
        'Digital Marketing/Social Media': 70,
        'Driving/Delivery': 89,
        Education: 44,
        Entertainment: 78,
        Entrepreneur: 79,
        'Health/Therapy': 103,
        'Human Resources': 62,
        'Insurance/Benefits Agent': 33,
        Legal: 53,
        'Maintenance/Repair': 78,
        Modeling: 106,
        'Photography/Videography': 70,
        'Programming/IT': 230,
        'Real Estate': 172,
        Sales: 55,
        Security: 78,
        'Sports/Fitness': 97,
        'Translation/Writing': 78
      }
    }
    let businessType = self.$customerDetails.segment
    let device = funcs.deviceType()
    // businessType = 'Security'
    // device = 'IOS'
    if (valueList[device] && valueList[device][businessType]) {
      return valueList[device][businessType]
    }
    return 0
  },
  enterEmail: function (self) {
    try {
      self.$gtm.trackEvent({
        event: 'enter_email'
      })
    } catch (err) {
      Bugsnag.notify(JSON.stringify('enterEmail', err))
    }
  },
  completeRegistration: function (self) {
    try {
      // FB, Google
      // if (self.$customerDetails && self.$customerDetails.segment !== 'Cleaning/Housekeeping' && self.$customerDetails.segment !== 'Caregiving') {
      // self.$mam.deduplicateEvent(
      //   'CompleteRegistration',
      //   self.$customerDetails.customerId
      // )
      // }
      let value = funcs.calcValue(self)
      if (value > 0) {
        self.$mam.eventWithValue('Purchase', value)
      }

      if (
        self.$customerDetails &&
        self.$customerDetails.segment !== 'Cleaning/Housekeeping' &&
        self.$customerDetails.segment !== 'Caregiving'
      ) {
        if (value > 0) {
          self.$gtm.trackEvent({
            event: 'complete_registration',
            value: value
          })
        } else {
          self.$gtm.trackEvent({
            event: 'complete_registration'
          })
        }
      } else {
        self.$gtm.trackEvent({
          event: 'complete_registration_other_segment'
        })
      }

      if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i)
      ) {
        self.$gtm.trackEvent({
          event: 'complete_registration_ios'
        })
      }

      // Snapchat
      window.dataLayer.user_email = self.$customerDetails.email
    } catch (err) {
      Bugsnag.notify(JSON.stringify('Error at completeRegistration', err))
    }
  },
  submitApplication: function (self) {
    try {
      // FB, Google
      // self.$mam.event('SubmitApplication')
      const ownershipPercent = {}
      const businessOwners = self.customer && self.customer.businessOwners
      ownershipPercent['ownership percentage'] = self.customer.ownershipPercent
      businessOwners.forEach((business, idx) => {
        ownershipPercent[`owner ${idx + 1}`] = business.ownershipPercent
      })

      mixpanel.track('submit_application', {
        numOfInvitedUBOs: businessOwners ? businessOwners.filter(businessOwner => businessOwner.role === UBORoles.PARTNER_FULL_ACCESS).length : 0,
        ...ownershipPercent
      }
      )
      mixpanel.people.set('Plan_type_on_submit', self.customer.profile)
      window.hj('identify', self.customer.profile)
      // Google ads
      self.$gtm.trackEvent({
        event: 'submit_application'
      })
    } catch (err) {
      Bugsnag.notify(JSON.stringify('Error at submitApplication', err))
    }
  },
  splitCookies: (splitBy = ';') => {
    return document.cookie.split(splitBy).map(c => c.trim())
  },
  parseCookiesByStartValue: (
    cookiesArr,
    cookiesIndicators,
    keyValueSeparator
  ) => {
    const keysToIgnore = ['convert_experiment_data']
    let cookiesObj = {}
    cookiesArr.forEach(c => {
      if (
        cookiesIndicators.some(indicator =>
          c.toLowerCase().startsWith(indicator.toLowerCase())
        )
      ) {
        let sepIdx = c.indexOf(keyValueSeparator)
        let cname = c.substring(0, sepIdx)
        let cvalue = c.substring(sepIdx + 1)
        if (cname === '_ga') {
          cname = 'CID'
        } if (cname === 'convert_experiment_data') {
          try {
            const convertData = JSON.parse(cvalue)
            for (const key in convertData) {
              const modKey = `LP_${key}`
              cookiesObj[modKey] = convertData[key]
            }
          } catch (e) {
            console.error(e)
          }
        }
        if (!keysToIgnore.includes(cname)) {
          cookiesObj[cname] = cvalue
        }
      }
    })
    if ('convert' in window) {
      try {
        const {experiments} = window.convert.currentData
        if (experiments) {
          const expId = Object.keys(experiments)[0]
          cookiesObj['OB_experiment_id'] = expId
          cookiesObj['OB_variation_id'] = experiments[expId].variation_id
          cookiesObj['OB_variation_name'] = experiments[expId].variation_name
        }
      } catch (e) {
        Bugsnag.notify('Handled error, no experiments]', e)
      }
    }
    return cookiesObj
  },
  getFilteredQueryParams: self => {
    const paramsToIgnore = ['token']
    const queryParams = self.$route.query
    const filteredParams = {}

    Object.entries(queryParams).forEach(([key, value]) => {
      if (!paramsToIgnore.includes(key)) {
        filteredParams[key] = value
      }
    })

    return filteredParams
  },
  isObjPopulated: obj => {
    return Object.keys(obj).length
  },
  buildAdSource: self => {
    const KEY_VALUE_SEPERATOR = '='
    let cookiesObj = {}
    let afuserid = ''
    const cookieLookupParams = params.paramsCookiesLookup
    // Get cookies array from Document. by default split by ";"
    let cookiesArr = funcs.splitCookies()
    let cookiesIndicators = [
      'utm',
      'afuserid',
      'r=',
      'ttclid',
      '_ga=',
      '_ga_VYHG5X0XGR=',
      'af_c_id',
      'af_adset_id',
      'af_ad_id',
      'af_adset',
      'af_keyword_id',
      'gclid',
      'convert_experiment_data'
    ]
    // Filter cookies by startsWith value, parse them and return object
    cookiesObj = funcs.parseCookiesByStartValue(
      cookiesArr,
      cookiesIndicators,
      KEY_VALUE_SEPERATOR
    )

    // If we have cookies Obj AND there is afuserid cookie => assign value to param "afUserId"
    if (cookiesObj && cookiesObj.afuserid) {
      afuserid = cookiesObj.afuserid
    }
    // Check if query params object is populated
    if (Object.keys(funcs.getFilteredQueryParams(self)).length) {
      let adSource = funcs.getFilteredQueryParams(self)

      // Clean obj

      for (const key in adSource) {
        if (adSource[key] && adSource[key].includes('{{')) {
          adSource[key] = ''
        }
      }

      // Check if referral is not exists in query params
      if (adSource.r) {
        self.$customerDetails.referralCode = adSource.r
      } else {
        // Check if Referral exists in cookies
        if (cookiesObj && cookiesObj.r) {
          // Set "r" key in adSource with referral value from cookie
          adSource.r = cookiesObj.r
          self.$customerDetails.referralCode = cookiesObj.r
        }
      }

      // Check for afuserid Cookie value and add it into the adSource object
      if (afuserid) {
        adSource.afuserid = afuserid
        if (!adSource.af_adid) {
          adSource.af_adid = afuserid
        }
      }

      // Get from cookie those values in case they don't exist in adSource
      cookieLookupParams.forEach(param => {
        if (!adSource[param] && cookiesObj[param]) {
          adSource[param] = cookiesObj[param]
        }
      })
      self.$customerDetails.adSource = JSON.stringify(adSource)
      self.$storage.set('adSource', JSON.stringify(adSource))
    } else {
      // If there are no query params => check for cookies
      if (funcs.isObjPopulated(cookiesObj)) {
        if (afuserid) {
          cookiesObj.afuserid = cookiesObj.af_adid = afuserid
        }
        // Set referral code value from cookies to customerDetails
        self.$customerDetails.referralCode = cookiesObj.r
        self.$storage.set('adSource', JSON.stringify(cookiesObj))
        self.$customerDetails.adSource = JSON.stringify(cookiesObj)
      } else {
        // If there is no cookies => check for localStorage
        try {
          // Try to parse the adSource
          const adSource = JSON.parse(self.$storage.get('adSource'))
          self.$customerDetails.adSource = adSource
          if (afuserid) {
            adSource.afuserid = adSource.af_adid = afuserid
          }
        } catch (err) {
          // If parse failed, we assign adSource as empty Object
          self.$storage.set('adSource', JSON.stringify({}))
          self.$customerDetails.adSource = JSON.stringify({})
        }
      }
    }
  },
  startOb: function (self) {
    funcs.buildAdSource(self)
    self.$store.state.done = false
    // Support continue deeplink
    if (
      self.$customerDetails.customerKey === undefined ||
      self.$customerDetails.customerKey === ''
    ) {
      self.$customerDetails.customerKey = self.$route.query.customer
    }

    if (
      self.$customerDetails.referralCode === undefined ||
      self.$customerDetails.referralCode === ''
    ) {
      self.$customerDetails.referralCode = self.$route.query.r
    }

    if (
      self.$customerDetails.sourcePlatform === undefined ||
      self.$customerDetails.sourcePlatform === ''
    ) {
      try {
        if (
          self.$route.query.source === undefined ||
          self.$route.query.source === ''
        ) {
          if (funcs.isJson(self.$storage.get('source'))) {
            self.$customerDetails.sourcePlatform = JSON.parse(
              self.$storage.get('source')
            )
          } else {
            self.$customerDetails.sourcePlatform = self.$storage.get('source')
          }
        } else {
          self.$customerDetails.sourcePlatform = self.$route.query.source
        }
        if (self.$customerDetails && self.$customerDetails.sourcePlatform) {
          self.$storage.set(
            'source',
            JSON.stringify(self.$customerDetails.sourcePlatform)
          )
        }
      } catch (err) {
        Bugsnag.notify(JSON.stringify('Error at startOb', err))
      }
    }

    if (
      self.$customerDetails.startOnboarding === undefined ||
      self.$customerDetails.startOnboarding === ''
    ) {
      self.$customerDetails.startOnboarding = new Date().getTime()
    }
    funcs.validateABTestEnroll(self)
    funcs.validateAccountTypeFlow(self)
    funcs.validateIncomeTypeFlow(self)
  },
  deviceType: function () {
    if (/Android/i.test(navigator.userAgent)) {
      return 'ANDROID'
    } else if (/iPad|iPhone|iPod/.test(navigator.platform)) {
      return 'IOS'
    } else {
      return 'OTHER'
    }
  },
  isJson: function isJson (str) {
    try {
      JSON.parse(str)
    } catch (err) {
      Bugsnag.notify(JSON.stringify('Error at isJson', err))
      return false
    }
    return true
  },
  validateIncomeTypeFlow: function (self) {
    const isForceEnroll = self.$route.query.force_enroll_income
    const isAlreadyEnrolled = JSON.parse(getFromLocal('isIncomeEnrolled'))
    const chance = isForceEnroll ? 100 : isAlreadyEnrolled ? 100 : 100
    const decisionStatus = getRandomiseFlowDecision(chance)
    setToLocalStorage({ key: 'isIncomeEnrolled', value: decisionStatus })
    self.$customerDetails.incomeTypeFlow = decisionStatus
  },
  validateAccountTypeFlow: async function (self) {
    self.$customerDetails.isAccountTypeFlow = true
  },
  validateABTestEnroll: function (self) {
    self.$customerDetails.isFeeABtestEnrolled = false
    self.$customerDetails.isABtestEnrolled = false
  }
}

export default funcs



// WEBPACK FOOTER //
// ./src/utils/tracking.js